import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
const {fontSemiBold, fontExtraBold, fontBold} = SkillzStyle.fullStyles;

export const styles = StyleSheet.create({
  accountDetailsContainer: {
    borderRadius: 5,
    borderColor: '#DCDCDC',
    borderWidth: 1,
    backgroundColor: '#FFF',
    paddingTop: 24,
    paddingBottom: 20,
    paddingHorizontal: 16,
    marginTop: 8,
    marginHorizontal: 10,
  },
  accountDetailsTitle: {
    fontSize: 16,
    color: '#333',
    ...fontExtraBold,
    marginBottom: 16,
  },
  accountDetailsLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    alignItems: 'center',
  },

  noMarginBottom: {
    marginBottom: 0,
  },

  accountDetailsLineKey: {
    fontSize: 12,
    ...fontBold,
    textTransform: 'uppercase',
    color: '#333',
  },

  lineWithIcon: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  amountStyle: {
    ...fontSemiBold,
    fontSize: 16,
    color: '#333',
  },
  amountStyleGray: {
    ...fontSemiBold,
    fontSize: 16,
    color: '#7A7A7A',
  },

  flexOne: {
    flex: 1,
  },
  infoButton: {
    marginRight: 5,
  },

  infoIcon: {
    width: 15,
    height: 15,
  },

  playthroughInfoContainer: {
    marginTop: 16,
  },
});
